
const PopupTypeEnum = {
    //MABAL
    HOW_TO_CALL_FROM_ISRAEL: 'HOW_TO_CALL_FROM_ISRAEL',


  };

  export default PopupTypeEnum;
